import { Box, InputLabel, Slider } from '@mui/material';
import { SUDOKU_DIFFICULTY_LABELS, SUDOKU_DIFFICULTY_OPTIONS, SudokuDifficulty } from '@/types/create/SudokuDifficulty';
import { Theme } from '@mui/material/styles';
import React, { FC } from 'react';

interface Props {
  value: SudokuDifficulty;
  onValueChange: (value: SudokuDifficulty) => void;
  disabled?: boolean;
}

const MARKS = SUDOKU_DIFFICULTY_OPTIONS.map((difficulty: SudokuDifficulty, index: number) => ({
  value: index,
  label: SUDOKU_DIFFICULTY_LABELS[difficulty],
}));

const MIXED_INDEX: number = SUDOKU_DIFFICULTY_OPTIONS.indexOf('MIXED');

export const SudokuDifficultySliderField: FC<Props> = (props: Props) => {
  const { value, onValueChange, disabled } = props;

  const valueIndex: number = SUDOKU_DIFFICULTY_OPTIONS.indexOf(value);
  const sliderValue: number = valueIndex >= 0 ? valueIndex : SUDOKU_DIFFICULTY_OPTIONS.indexOf('MEDIUM');

  return (
    <Box position={'relative'}>
      <InputLabel disableAnimation={true} shrink={false}>
        {'Сложность'}
      </InputLabel>
      <Box sx={{ mx: 2 }}>
        <Slider
          size={'small'}
          value={sliderValue}
          min={0}
          max={SUDOKU_DIFFICULTY_OPTIONS.length - 1}
          step={null}
          marks={MARKS}
          disabled={disabled}
          onChange={(event: Event, newValue: number | number[]): void => {
            onValueChange(SUDOKU_DIFFICULTY_OPTIONS[newValue as number]);
          }}
          sx={{
            '& .MuiSlider-mark': {
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: (theme: Theme) => theme.colors.grayText,
            },
            // Passed stops merge into the filled track so the line stays solid.
            '& .MuiSlider-mark.MuiSlider-markActive': {
              display: 'none',
            },
            '& .MuiSlider-markLabel': {
              color: (theme: Theme) => theme.colors.grayText,
              fontSize: '12px',
            },
            [`& .MuiSlider-markLabel[data-index="${MIXED_INDEX}"]`]: {
              color: (theme: Theme) => theme.colors.primary,
            },
          }}
        />
      </Box>
    </Box>
  );
};
